<template>
  <div class="course-page" v-loading="loading">
    <div class="course-wrapper">
      <div class="course-container">
        <div class="course-bar">
          <div :class="['item', { active: idx === active || (idx === 1 && idx <= active) }]" v-for="(item, idx) in navbar" :key="item">{{ item }}</div>
        </div>
        <div class="course-content">
          <div class="course-title">
            <div :class="['item', { active: idx <= active }]" v-for="(item, idx) in steps" :key="item">{{ item }}</div>
          </div>
          <div v-if="active === 0" class="course-step1">
            <el-form :model="formData" :rules="rules" ref="form1" label-width="150rem" label-position="right">
              <el-form-item label="学段" prop="apply_type">
                <el-radio-group v-model="formData.apply_type" size="small" @change="onChangeApplyType">
                  <el-radio v-for="item in options1" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="科目" prop="subject_id">
                <el-radio-group v-model="formData.subject_id" size="small">
                  <el-radio v-for="item in options2" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="教学年级" prop="teach_grade">
                <el-checkbox-group v-model="formData.teach_grade" size="small">
                  <el-checkbox  v-for="item in options3" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="关联教材" prop="video_article_basic_id">
                <el-select v-model="formData.video_article_basic_id" filterable placeholder="请选择" :loading="searchLoading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="formData.remark" placeholder="请输入" :maxlength="300" show-word-limit :autosize="{ minRows: 8, maxRows: 20}"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-else-if="active === 1" class="course-step2">
            <div class="step-item course-list-wrapper">
              <div class="course-list-dialog" v-if="dialogShow">
                <div class="course-list-dialog-inner">
                  <el-input class="course-list-dialog-input" v-model="dialogValue" placeholder="请输入讲次" maxlength="30"></el-input>
                  <div class="flex justify-end">
                    <el-button type="primary" @click="handleSaveCourse">保存</el-button>
                    <el-button @click="handleCancelCourse">取消</el-button>
                  </div>
                </div>
              </div>
              <div class="course-list-title">讲次列表</div>
              <draggable
                class="course-list-content"
                v-model="courseList"
                v-bind="{
                  group: 'description',
                  animation: 200,
                  disabled: false,
                  handle: '.drag-btn',
                  chosenClass: 'drag-choose',
                  ghostClass: 'drag-move',
                }"
                @change="handleSortCourse"
              >
                <div :class="['course-list-item', { active: idx === courseIdx }]"
                  v-for="(item, idx) in courseList" :key="item.id"
                  @click.prevent="handleSelectCourse(idx)"
                >
                  <div class="info">
                    <div class="no flex-center">第{{ idx+1 }}讲</div>
                    <div :class="['title', { empty: !item.article_name }]">{{ item.article_name || '请输入讲次' }}</div>
                  </div>
                  <div class="action">
                    <el-button circle plain type="success" size="small" icon="el-icon-edit" @click.stop="handleEditCourse(item, idx)"></el-button>
                    <el-button circle plain type="danger" size="small" icon="el-icon-delete" @click.stop="handleDeleteCourse(item, idx)"></el-button>
                    <el-button circle plain type="warning" size="small" icon="el-icon-rank" class="drag-btn" @click.stop></el-button>
                  </div>
                </div>
                <div v-if="!courseList.length" class="flex-center course-list-empty">请添加讲次</div>
              </draggable>
              <div class="course-list-add">
                <el-button class="course-list-add-btn" icon="el-icon-plus" @click="handleAddCourse">添加讲次</el-button>
              </div>
            </div>
            <div class="step-item course-file-wrapper">
              <div v-if="courseIdx === -1" class="flex-center course-file-empty">
                <Empty  />
              </div>
              <template v-else>
                <div class="course-file-tabs">
                  <div
                  :class="['item', { active: idx === typeIdx }]"
                  v-for="(item, idx) in types" :key="item.value"
                  @click="handleChangeType(idx)"
                  >{{ item.label }}</div>
                </div>
                <div class="course-file-content">
                  <div class="course-file-item" v-if="typeIdx === 0">
                    <UploadFile class="h100" type="ppt" size="200" :list="courseResourceList" @change="e => handleUpload(e, 0)"></UploadFile>
                  </div>
                  <div class="course-file-item video" v-else-if="typeIdx === 4">
                    <div class="course-file-search">
                      <el-select
                        style="width: 100%;"
                        v-model="searchValue"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请搜索"
                        :remote-method="remoteMethod"
                        :loading="searchLoading"
                      >
                        <el-option
                          v-for="item in options5"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="course-file-search-upload" @click="handleChoose">搜不到？点此上传视频</div>
                    </div>
                    <div class="course-file-video">
                      <div style="height: 40rem;font-size: 20rem;">已添加视频</div>
                      <UploadFile ref="uploadVideo" style="height: calc(100% - 40rem);" type="video" size="500" :list="courseResourceList" @change="e => handleUpload(e, 4)"></UploadFile>
                    </div>
                  </div>
                  <div class="course-file-item" v-else-if="typeIdx === 1">
                    <UploadFile class="h100" type="file" size="200" :list="courseResourceList" @change="e => handleUpload(e, 1)"></UploadFile>
                  </div>
                  <div class="course-file-item" v-else-if="typeIdx === 2">
                    <UploadFile class="h100" type="file" size="200" :list="courseResourceList" @change="e => handleUpload(e, 2)"></UploadFile>
                  </div>
                  <div class="course-file-item" v-else-if="typeIdx === 3">
                    <UploadFile class="h100" type="file" size="200" :list="courseResourceList" @change="e => handleUpload(e, 3)"></UploadFile>
                  </div>
                  <div class="course-file-item" v-else-if="typeIdx === 5">
                    <UploadFile class="h100" type="file" size="200" :list="courseResourceList" @change="e => handleUpload(e, 5)"></UploadFile>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div v-else class="course-step3">
            <div class="success-box">
              <el-image class="img" src="/img/success-1.png"></el-image>
              <div class="title">提交成功</div>
              <div class="desc">可以在教学端和黑板端查看已经添加的课程文件</div>
              <el-button plain type="primary" @click="$router.back()">跳转到列表页</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="course-footer">
        <template v-if="active === 0">
          <el-button :disabled="loading" @click="handleBack">取消</el-button>
          <el-button :loading="loading" type="primary" @click="handleNext('form1')">下一步</el-button>
        </template>
        <template v-else-if="active === 1">
          <el-button :disabled="loading" @click="active = 0">上一步</el-button>
          <el-button :loading="loading" type="primary" plain @click="handleSubmit(1)">暂存</el-button>
          <el-button :loading="loading" type="primary" @click="handleSubmit(0)">提交</el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Dialog from '@/components/common/Dialog'
import Empty from '@/components/common/ZuEmpty'
import UploadFile from '@/components/common/ZuUploadFile.vue'
import { formDataBackMixin } from '@/utils/mixins'
import { objectIsEmpty, changeOption, transformAddOrEditData } from '@/utils'
import { getFileType } from '@/components/common/tools'
import http, { changeObjToArr } from '@/api'

export default {
  _config:{'route':[{'path':'edit','meta':{'title':'编辑'}}, {'path':'add','meta':{'title':'新增'}}]},
  components: { draggable, Dialog, Empty, UploadFile },
  mixins: [formDataBackMixin],
  data() {
    return {
      navbar: ['基本信息', '课程讲次'],
      steps: ['基本信息', '上传节次信息', '提交本次课程'],
      types: [
        { value: 4, label: 'PPT课件' },
        { value: 2, label: '学案' },
        { value: 3, label: '作业案' },
        { value: 1, label: '教案' },
        { value: 6, label: '视频' },
        { value: 5, label: '课堂资源' }
      ],
      init: true,
      count: 0,
      active: 0,
      courseIdx: -1,
      typeIdx: 0,
      id: '',
      dialogShow: false,
      dialogValue: '',
      dialogIdx: -1,
      loading: false,
      searchLoading: false,
      searchValue: '',
      list: [],
      formData: {
        apply_type: '',
        subject_id: '',
        teach_grade: [],
        video_article_basic_id: '',
        remark: ''
      },
      rules: {
        apply_type: [{ required: true, message: '请选择', trigger: 'change' }],
        subject_id: [{ required: true, message: '请选择', trigger: 'change' }],
        teach_grade: [{ required: true, message: '请选择', trigger: 'change' }],
        video_article_basic_id: [{ required: true, message: '请选择', trigger: 'change' }],
        remark: [{ required: true, message: '请输入300字以内的说明', trigger: 'change' }]
      },
      teach_grade: {},
      options1: [],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      courseList: [],
      maxlength: 10000,
      typeList: [],
      mimeMapList: []
    }
  },
  computed: {
    listenChange() {
      const { apply_type, subject_id } = this.formData
      return { apply_type, subject_id }
    },
    courseResourceList() {
      if (this.courseIdx === -1) return []
      const list = this.courseList[this.courseIdx].time_course_resource[this.typeIdx].resource_list
      return list
    },
  },
  watch: {
    listenChange(val) {
      const { apply_type, subject_id } = val
      if (apply_type && subject_id) {
        this.getOptions({ apply_type, subject_id })
      }
    },
    count(val) {
      if (val && !this.loading) {
        this.loading = true
      } else if (!val && this.loading) {
        this.init = false
        this.loading = false
      }
    },
    searchValue(val) {
      if (!val) return
      const k = this.options5.find(i => i.id.includes(val))
      if (!k) return
      const { id, label, value, ...other } = k
      const data = { status: 'uploaded', name: k.file_name, type: k.file_extension, size: k.file_size, data: { ...other } }
      this.courseList[this.courseIdx].time_course_resource[this.typeIdx].resource_list.push(data)
      this.options5 = []
      this.searchValue = ''
    }
  },
  created() {
    this.getConfig()
    this.getData()
  },
  methods: {
    getConfig() {
      const { mimeMapList, typeList } = getFileType()
      this.typeList = typeList
      this.mimeMapList = mimeMapList
      this.count++
      http({ url: '/time-course/get-conf', pre: 'zh' }).then(res => {
        const { apply_type = [], subject_id = [], teach_grade = {} } = res
        this.options1 = changeOption({ list: apply_type, value: 'id', label: 'apply_name' })
        this.options2 = changeOption({ list: subject_id, value: 'id', label: 'subject_name' })
        // this.options3 = changeObjToArr(teach_grade)
        let obj = {}
        for (const key in teach_grade) {
          obj[key] = changeObjToArr(teach_grade[key])
        }
        this.teach_grade = obj
        const key = this.formData.apply_type || 4
        if (key) this.options3 = this.teach_grade[key]
      }).finally(() => this.count--)
    },
    getData() {
      const id = this.$route.query.id
      if (!id) return
      this.count++
      this.id = id
      http({ url: '/time-course/get', pre: 'zh' }, { id }).then(res => {
        this.formData = {
          apply_type: res.apply_type,
          subject_id: res.subject_id,
          teach_grade: res.teach_grade,
          video_article_basic_id: res.video_article_basic_id,
          remark: res.remark
        }
        const list = res.time_course_article || []
        const arr = list.map((i) => {
          const arr = this.types.map(item => {
            const obj = i.time_course_resource.find(j => j.resource_type === item.value)
            if (obj) {
              return { ...obj, resource_list: obj.resource_list.map((k) => {
                return { status: 'uploaded', name: k.file_name, type: k.file_extension, size: k.file_size, data: { ...k } }
              })}
            }
            return {
              resource_type: item.value, resource_list: []
            }
          })
          return { ...i, time_course_resource: arr }
        })
        this.courseList = arr
      }).finally(() => this.count--)
    },
    getOptions(data) {
      if (!this.init && this.formData.video_article_basic_id) {
        this.formData.video_article_basic_id = ''
        this.$nextTick(() => {
          this.$refs.form1.clearValidate(['video_article_basic_id'])
        })
      }
      this.options4 = []
      this.searchLoading = true
      http({ url: '/time-course/search', pre: 'zh' }, data).then(res => {
        this.options4 = changeOption({ list: res, value: 'id', label: 'teach_name' })
      }).finally(() => this.searchLoading = false)
    },
    handleNext(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        this.active++
      })
    },
    handleSubmit(is_cached) {
      if (!this.courseList.length) return this.$message.warning('请添加讲次')
      const isEvery = this.courseList.every(item => item.article_name)
      if (!isEvery) return this.$message.warning('请输入讲次名称')
      let isOk = true
      const time_course_article = transformAddOrEditData(this.courseList).map((i,j) => {
        const { time_course_resource } = i
        const list = time_course_resource.map(item => {
          const { resource_list } = item
          const arr = resource_list.map((child) => {
            let data = {}
            if (['success', 'uploaded'].includes(child.status)) {
              data = { file_type: 0, ...child.data }
            } else {
              isOk = false
            }
            return data
          })
          return { ...item, resource_list: arr }
        })
        return { ...i, sort_num: j+1, time_course_resource: list }
      })
      if (!isOk) return this.$message.warning('请重新上传或删除失败文件！')
      const data = { ...this.formData, time_course_article, is_cached }
      const url = `/time-course/${this.id ? 'edit' : 'add'}`
      if (this.id) { data.id = this.id }
      this.loading = true
      http({ url, method: this.id ? 'put' : 'post', pre: 'zh' }, data).then(() => {
        if (is_cached) {
          this.$message.success('暂存成功')
          this.$router.back()
          return
        }
        this.$message.success(`${this.id ? '编辑' : '添加'}成功`)
        this.active++
      }).finally(() => this.loading = false)
    },
    handleBack() {
      this.formBack(this.formData)
    },
    handleSortCourse(val) {
      const { moved: { newIndex, oldIndex } } = val
      if (this.courseIdx === newIndex) {
        this.courseIdx = oldIndex
      } else if (this.courseIdx === oldIndex) {
        this.courseIdx = newIndex
      }
    },
    handleSelectCourse(idx) {
      this.typeIdx = 0
      if (this.courseIdx === idx) {
        // this.courseIdx = -1
        return
      }
      this.courseIdx = idx
    },
    getResource() {
      const arr = this.types.map(item => ({ resource_type: item.value, resource_list: [] }))
      return arr
    },
    handleAddCourse() {
      if (this.courseList.length >= this.maxlength) return this.$message.warning(`最多添加${this.maxlength}条`)
      this.courseList.push({ id: Date.now(), article_name: '', time_course_resource: this.getResource(), isAdd: 1 })
    },
    handleEditCourse(item, idx) {
      const { article_name } = item
      this.dialogShow = true
      this.dialogValue = article_name
      this.dialogIdx = idx
    },
    handleSaveCourse() {
      if (!this.dialogValue) return this.$message.warning('请输入')
      this.courseList[this.dialogIdx].article_name = this.dialogValue
      this.handleCancelCourse()
    },
    handleCancelCourse() {
      this.dialogShow = false
      this.dialogValue = ''
      this.dialogIdx = -1
    },
    handleDelete(idx) {
      this.courseIdx = -1
      this.courseList.splice(idx, 1)
    },
    handleDeleteCourse(item, idx) {
      if (objectIsEmpty(item, ['isAdd'])) return this.handleDelete(idx)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({type: 'success', message: `删除成功!`})
      })
    },
    remoteMethod(query) {
      if (!query) {
        this.options5 = []
        return
      }
      this.searchLoading = true
      http({ url: '/vod/list-v2', pre: 'api4' }, { q: query, start: 0, limit: 10 }).then(res => {
        const list = res.rows || []
        this.options5 = list.map(item => {
          let type = 'file'
          if (this.typeList.includes(item.file_extension)) type = item.file_extension
          else if (this.mimeMapList[item.file_extension]) type = this.mimeMapList[item.file_extension]
          return { ...item, file_extension: type, value: item.id, label: item.file_name }
        })
      }).finally(() => this.searchLoading = false)
    },
    handleChangeType(idx) {
      this.typeIdx = idx
    },
    handleUpload(e ,idx) {
      this.courseList[this.courseIdx].time_course_resource[idx].resource_list = e
    },
    handleChoose() {
      this.$refs.uploadVideo.handleChoose()
    },
    onChangeApplyType(val) {
      this.options3 = this.teach_grade[val]
      if (!this.formData.teach_grade.length) return
      this.formData.teach_grade = []
      this.$nextTick(() => {
        this.$refs.form1.clearValidate(['teach_grade'])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.course {
  $radius: 14rem;
  &-page {
    background-color: #f7f7f7 !important;
  }
  &-wrapper {
    width: calc(100% - 20rem);
    height: calc(100vh - 120rem);
    padding: 20rem 24rem 0;
    display: flex;
    flex-direction: column;
    border-radius: 8rem;
    overflow: hidden;
  }
  &-container {
    height: calc(100vh - 210rem);
  }
  &-footer {
    padding-right: 20rem;
    height: 70rem;
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  &-bar {
    height: 60rem;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    $height: 50rem;
    $add: 6rem;
    $bgColor: #E3ECFC;
    $activeBgColor: #fff;
    .item {
      z-index: 1;
      position: relative;
      width: 140rem;
      height: $height;
      color: #0256FF;
      font-size: 18rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $bgColor;
      border-radius: 12rem 12rem 0 0;
      transition: height 0.2s;
      user-select: none;
      &.active {
        z-index: 2;
        height: calc($height + $add);
        margin-top: -$add;
        color: #2A2E3C;
        border-radius: $radius $radius 0 0;
        background-color: $activeBgColor;
        box-shadow: $radius $radius 0 0 $activeBgColor, -$radius $radius 0 0 $activeBgColor;
      }
      &:last-child {
        &::after {
          content: '';
          background-color: #f7f7f7;
        }
      }
      &::before, &::after {
        content: '';
        z-index: 1;
        position: absolute;
        bottom: 0;
        width: 20rem;
        height: $height;
        background-color: $bgColor;
      }
      &::before {
        left: -20rem;
        border-bottom-right-radius: 20rem;
      }
      &::after {
        right: -20rem;
        border-bottom-left-radius: 20rem;
      }
    }
  }
  &-content {
    height: calc(100vh - 270rem);
    padding: 20rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #fff;
    border-radius: 0 $radius $radius $radius;
    box-sizing: border-box;
  }
  &-title {
    padding-bottom: 20rem;
    display: flex;
    flex-shrink: 0;
    .item {
      $bgColor: #f3f3f3;
      $activeBgColor: #025DF4;
      position: relative;
      height: 40rem;
      padding: 0 20rem;
      color: #666;
      background-color: #f3f3f3;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      user-select: none;
      &:first-child {
        &::before {
          content: none;
        }
      }
      &:last-child {
        &::after {
          content: none;
        }
      }
      &::before, &::after {
        content: '';
        z-index: 1;
        position: absolute;
        bottom: 0;
        width: 0;
        height: 0;
      }
      &::before {
        left: 0;
        border-style: solid;
        border-color: transparent transparent transparent #fff;
        border-width: 20rem 20rem 20rem 14rem;
      }
      &::after {
        right: -33rem;
        border-style: solid;
        border-color: transparent transparent transparent $bgColor;
        border-width: 20rem 20rem 20rem 14rem;
      }
      + .item {
        margin-left: 18rem;
      }
      &.active {
        color: #fff;
        background-color: $activeBgColor;
        &::after {
          border-color: transparent transparent transparent $activeBgColor;
        }
      }
    }
  }
  &-step1 {
    flex: 1;
    overflow-y: auto;
  }
  &-step2 {
    display: flex;
    flex: 1;
    box-sizing: border-box;
    .course-list {
      &-wrapper {
        position: relative;
        width: 40%;
        height: calc(100vh - 370rem);
        background-color: #F7F7F7;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
      }
      &-title {
        height: 70rem;
        padding: 0 20rem;
        font-size: 20rem;
        color: #2A2E3C;
        flex-shrink: 0;
        display: flex;
        align-items: center;
      }
      &-content {
        padding: 0 20rem;
        flex: 1;
        overflow-y: auto;
      }
      &-add {
        height: 80rem;
        padding: 20rem;
        flex-shrink: 0;
        &-btn {
          width: 100%;
          height: 40rem;
        }
      }
      &-empty {
        height: 100%;
        color: #333;
        font-size: 22rem;
      }
      &-dialog {
        z-index: 10;
        position: absolute;
        inset: 0;
        background-color: rgba($color: #000000, $alpha: 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        &-inner {
          width: calc(100% - 48rem);
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        &-input {
          height: 80rem;
          margin-bottom: 20rem;
          border-radius: 4rem;
          font-size: 14rem;
          box-sizing: border-box;
          :deep(.el-input__inner) {
            height: 100%;
          }
        }
      }
      &-item {
        position: relative;
        padding: 10rem;
        color: #2A2E3C;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        border: solid 1px #fff;
        border-radius: 4rem;
        user-select: none;
        cursor: pointer;
        &:not(:last-child) {
          margin-bottom: 10rem;
        }
        &.active {
          border-color: #8AB0EE;
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            width: 2rem;
            height: 22rem;
            transform: translateY(-50%);
            background-color: #3A80F6;
          }
        }
        &.drag-choose {
          border-color: #fdc29e;
        }
        &.drag-move {
          opacity: 0.5;
        }
        .info {
          min-width: 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .no {
          width: 74rem;
          height: 46rem;
          margin-right: 14rem;
          font-size: 14rem;
          background-color: #DEE8FF;
          border-radius: 3rem;
          flex-shrink: 0;
        }
        .title {
          min-width: 0;
          font-size: 12rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.empty {
            color: #aaa;
          }
        }
        .action {
          margin-left: 14rem;
          flex-shrink: 0;
        }
      }
    }
    .course-file {
      &-wrapper {
        height: calc(100vh - 370rem);
        display: flex;
        flex-direction: column;
        background-color: #F8FAFB;
        flex: 1;
      }
      &-empty {
        height: 100%;
      }
      &-tabs {
        height: 55rem;
        flex-shrink: 0;
        display: flex;
        align-items: stretch;
        background-color: #C8E3FF;
        .item {
          position: relative;
          width: 128rem;
          color: #36507E;
          font-size: 18rem;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &.active {
            color: #1C4EFD;
            &::after {
              content: '';
              position: absolute;
              bottom: 13rem;
              left: 50%;
              width: 26rem;
              height: 2rem;
              background-color: #1C4EFD;
              transform: translateX(-50%);
            }
          }
        }
      }
      &-content {
        flex: 1;
      }
      &-item {
        padding: 30rem 24rem;
        height: calc(100vh - 425rem);
        overflow-y: auto;
        &.video {
          padding: 0;
          display: flex;
          flex-direction: column;
        }
      }
      &-search {
        height: 120rem;
        padding: 30rem 24rem;
        flex-shrink: 0;
        &-upload {
          margin-top: 10rem;
          font-size: 12rem;
          color: #3491FA;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      &-video {
        padding: 20rem 24rem;
        flex: 1;
        overflow-y: auto;
        background-color: #F0F5FD;
        .title {
          font-size: 20rem;
          color: #2A2E3C;
          padding-bottom: 25rem;
        }
      }
    }
  }
  &-step3 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    .success-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .img {
        width: 256rem;
        height: 216rem;
      }
      .title {
        font-size: 36rem;
        color: #2A2E3C;
        margin-top: 10rem;
      }
      .desc {
        margin-top: 20rem;
        margin-bottom: 20rem;
        font-size: 14rem;
        color: #8F959E;
      }
    }
  }
}

::v-deep input[aria-hidden='true'] {
display: none !important;
}
::v-deep.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
box-shadow: none !important;
}
</style>
